// @ts-nocheck
import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const ClusterMarker = ({
  lat,
  lng,
  isActive,
  selectDealer,
  name,
  indx,
  supercluster,
  mapRef,
  points,
  pointCount,
  cluster
}) => {
  const ClusterMarkerRef = useRef();

  if (!lat && !lng) {
    return false;
  }

  return (
    <div
      className={`dealer-page__cluster-marker${isActive ? '--active' : ''}`}
      style={{
        width: `${44 + (pointCount / points.length) * 20}px`,
        height: `${44 + (pointCount / points.length) * 20}px`,
      }}
      onClick={() => {
        const expansionZoom = Math.min(
          supercluster.getClusterExpansionZoom(cluster.id),
          20
        );
        mapRef.current.setZoom(expansionZoom);
        mapRef.current.panTo({ lat, lng });
      }}
    >
      <span>{pointCount}</span>
    </div>
  );
};

export default React.memo(ClusterMarker);
